module.exports = __webpack_public_path__ + "media/clip_3.69a6262e.mp4";